import React, { Component } from 'react';

import { API_BASE_URL } from '../apiConfig';
import { parseApiResponse } from '../lib/apiClient';
import {Navbar, Account, Dev, Home, Modal, Events, PichyBubble} from './partials/index';

class Dashboard extends Component {

    state = {
        msg: '',
        userData: '',
        userTransactions: [],
        systemEvents: []
    }

    getUserData = () => {
        if(window.localStorage.getItem('userData')){
            const url = `${API_BASE_URL}/api/account`;

            fetch(url, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache': 'no-cache'
                }
            })
            .then(parseApiResponse)
            .then(result => {
                if(result.msg === 'User data'){
                    this.setState({ userData : result.userData })
                    window.localStorage.setItem('userData', JSON.stringify(result.userData))
                }else{
                    localStorage.clear();
                    window.location.href = '/'
                }
            })
            .catch(() => {
                localStorage.clear();
                window.location.href = '/'
            })
        }else{
            localStorage.clear();
            window.location.href = '/'
        }
    }

    getUserTransactions = () => {
        if(window.localStorage.getItem('userData')){
            
            const url = `${API_BASE_URL}/api/account/transactions`;
            
            fetch(url, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache': 'no-cache'
                }
            })
            .then(parseApiResponse)
            .then(result => {
                if(result.msg === 'User transactions'){
                    this.setState({ userTransactions : result.userTransactions })
                }else{
                    localStorage.clear();
                    window.location.href = '/'
                }
            })
            .catch(() => {
                localStorage.clear();
                window.location.href = '/'
            })
        }else{
            localStorage.clear();
            window.location.href = '/'
        }
    }

    getSystemEvents = () => {
        if(window.localStorage.getItem('userData')){
            
            const url = `${API_BASE_URL}/api/event-log`;
            
            fetch(url, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
            })
            .then(parseApiResponse)
            .then(result => {
                if(result.msg === 'Event data'){
                    this.setState({ systemEvents : result.eventData })
                }else{
                    localStorage.clear();
                    window.location.href = '/'
                }
            })
            .catch(() => {
                localStorage.clear();
                window.location.href = '/'
            })
        }else{
            localStorage.clear();
            window.location.href = '/'
        }
    }

    withdrawalMoney = (e) => {
        e.preventDefault()
        let wdwAmount = document.querySelector('#withdrawal').value
        let msgBox = document.querySelector('.wdw-msg')

        if(wdwAmount <= 0){
            msgBox.innerText = 'Please enter a valid amount.'
            return;
        }else{
            const url = `${API_BASE_URL}/api/account/wdw`;

            fetch(url, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache': 'no-cache'
                },
                body: new URLSearchParams({
                    withdrawal: wdwAmount,
                })
            })
            .then(parseApiResponse)
            .then(result => {
                if(result.msg === 'Withdrawal completed'){
                    this.setState({ userData : result.userData })
                    window.localStorage.setItem('userData', JSON.stringify(this.state.userData))
                    msgBox.style.color = '#00FF00';
                    msgBox.innerText = 'Withdrawal completed';
                    this.getUserTransactions()
                }else{
                    msgBox.innerText = result.msg
                }
            })
            .catch((err) => {
                msgBox.innerText = err.message || 'Withdrawal failed.'
            })
        }
    }

    depositMoney = (e) => {
        e.preventDefault()
        let msgBox = document.querySelector('.dpst-msg')
        let currentBalance = this.state.userData.balance
        
        if(Number(currentBalance.replace(/[^0-9.-]+/g,"")) > 250){
            msgBox.innerText = 'You can reset your balance when is below $250'
            return;
        }else{
            const url = `${API_BASE_URL}/api/account/deposit`;

            fetch(url, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache': 'no-cache'
                }
            })
            .then(parseApiResponse)
            .then(result => {
                if(result.msg === 'Balance updated'){
                    this.setState({ userData : result.userData })
                    window.localStorage.setItem('userData', JSON.stringify(this.state.userData))
                    msgBox.style.color = '#00FF00';
                    msgBox.innerText = 'Balance updated';
                    this.getUserTransactions()
                }else{
                    msgBox.innerText = result.msg
                }
            })
            .catch((err) => {
                msgBox.innerText = err.message || 'Deposit failed.'
            })
        }
    }

    transferMoney = (e) => {
        e.preventDefault()
        let receptor = document.querySelector('#transfer-email').value
        let transferAmount = document.querySelector('#transfer-amount').value

        let msgBox = document.querySelector('.trsf-msg')

        let currentBalance = this.state.userData.balance

        if(transferAmount <= 0 || receptor.length <= 0){
            msgBox.innerText = 'Email and amount are required.'
            return;
        }else if(Number(currentBalance.replace(/[^0-9.-]+/g,"")) < transferAmount){
            msgBox.innerText = 'Not enough money.'
            return;
        }else{
            const url = `${API_BASE_URL}/api/account/transfer`;

            fetch(url, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache': 'no-cache'
                },
                body: new URLSearchParams({
                    email: receptor,
                    transfer : transferAmount
                })
            })
            .then(parseApiResponse)
            .then(result => {
                if(result.msg === 'Transfer completed'){
                    this.setState({ userData : result.userData })
                    window.localStorage.setItem('userData', JSON.stringify(this.state.userData))
                    msgBox.style.color = '#00FF00';
                    msgBox.innerText = 'Transfer completed';
                    this.getUserTransactions()
                }else{
                    msgBox.innerText = result.msg
                }
            })
            .catch((err) => {
                msgBox.innerText = err.message || 'Transfer failed.'
            })
        }
    }

    accountUpdate = (e) => {
        e.preventDefault()
        let guid = document.querySelector('#guid').value
        let passwordNew = document.querySelector('#password-new').value
        let confirmation = document.querySelector('#confirmation').value

        let msgBox = document.querySelector('.usrup-msg')
        
        if(passwordNew !== confirmation){
            msgBox.innerText = 'New passwords do not match.'
            return;
        }else{
            const url = `${API_BASE_URL}/api/account/update`;

            fetch(url, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache': 'no-cache'
                },
                body: new URLSearchParams({
                    guid: guid,
                    passwordNew : passwordNew,
                    confirmation : confirmation,
                })
            })
            .then(parseApiResponse)
            .then(result => {
                if(result.msg === 'The password has been updated'){
                    msgBox.style.color = '#00FF00';
                    msgBox.innerText = 'The password has been updated';
                }else{
                    msgBox.innerText = result.msg
                }
            })
            .catch((err) => {
                msgBox.innerText = err.message || 'Password update failed.'
            })
        }
    }

    updateProfile = (e) => {
        e.preventDefault()
        const description = document.querySelector('#profile-description').value
        const msgBox = document.querySelector('.profile-msg')
        const url = `${API_BASE_URL}/api/account/profile`

        fetch(url, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache': 'no-cache'
            },
            body: new URLSearchParams({ description })
        })
        .then(parseApiResponse)
        .then(result => {
            if (result.msg === 'Profile updated') {
                const updated = { ...this.state.userData, description }
                this.setState({ userData: updated })
                window.localStorage.setItem('userData', JSON.stringify(updated))
                msgBox.style.color = '#00FF00'
                msgBox.innerText = 'Profile saved.'
            } else {
                msgBox.innerText = result.msg
            }
        })
        .catch((err) => {
            msgBox.innerText = err.message || 'Save failed.'
        })
    }

    componentDidMount(){
        document.querySelector('title').innerText = 'PenchukBank | Dashboard'

        if(window.localStorage.getItem('userData')){
            let data = JSON.parse(window.localStorage.getItem('userData'));
            this.setState({ userData : data });
        }

        this.getUserData()
        this.getUserTransactions()
        this.getSystemEvents()
    }

    render(){

        return(
            <div className="App">
                <div className="dashboard-container">
                    <Navbar 
                        userData = {this.state.userData}
                    />
                    <br />
                    <Home
                        userData = {this.state.userData}
                        userTransactions = {this.state.userTransactions}
                    />
                    <Account
                        userData = {this.state.userData}
                    />
                    <Events
                        systemEvents = {this.state.systemEvents}
                    />
                    <PichyBubble
                        userId = {this.state.userData.id}
                        userData = {this.state.userData}
                        onActivity = {() => {
                            this.getUserData()
                            this.getUserTransactions()
                        }}
                    />
                </div>
                <Modal
                    depositMoney = {this.depositMoney}
                    withdrawal = {this.withdrawalMoney}
                    transfer = {this.transferMoney}
                    accountUpdate = {this.accountUpdate}
                    updateProfile = {this.updateProfile}
                    userData = {this.state.userData}
                />
            </div>
        )
    }
}

export default Dashboard;
